<template>
  <div class="d-flex item-badge">
    <span class="ml-3" style="float:right">2</span>
    <div class="item-image" style="float:right"></div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    image: String,
    number: String
  },
  created () {
  }
}
</script>

<style>
  .item-badge {
    align-items: center;
  }
  .item-image {
    width: 24px;
    height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SidebarMenuBadge.vue